/* eslint-disable no-unused-vars */
// react
import React from 'react';

// application
import FooterContacts from './FooterContacts';
import FooterLinks from './FooterLinks';
import FooterNewsletter from './FooterNewsletter';
import ToTop from './ToTop';

// data stubs
import theme from '../../data/theme';

export default function Footer() {
    const informationLinks = [
        { title: 'Terminos y Condiciones', url: '/site/terms' },
        { title: 'Acerca de OFFIX', url: '/site/about-us' },
        { title: 'Informacion de Entrega', url: '' },
        { title: 'Política de Privacidad', url: '/site/privacy' },
        // { title: 'Brands', url: '' },
        { title: 'Contáctenos', url: '/site/contact-us-alt' },
        { title: 'FAQs', url: '/site/faq' },
        // { title: 'Site Map', url: '' },
    ];

    // const accountLinks = [
    //     { title: 'Store Location', url: '' },
    //     { title: 'Order History', url: '' },
    //     { title: 'Wish List', url: '' },
    //     { title: 'Newsletter', url: '' },
    //     { title: 'Specials', url: '' },
    //     { title: 'Gift Certificates', url: '' },
    //     { title: 'Affiliate', url: '' },
    // ];

    return (
        <div className="site-footer">
            <div className="container">
                <div className="site-footer__widgets">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-5">
                            <FooterContacts />
                        </div>
                        <div className="col-6 col-md-3 col-lg-3">
                            <FooterLinks title="Información" items={informationLinks} />
                        </div>
                        {/* <div className="col-6 col-md-3 col-lg-2">
                            <FooterLinks title="My Account" items={accountLinks} />
                        </div> */}
                        <div className="col-12 col-md-12 col-lg-4">
                            <FooterNewsletter />
                        </div>
                    </div>
                </div>

                {/* <div className="site-footer__bottom">
                    <div className="site-footer__copyright">
                        Powered by
                        {' '}
                        <a href="https://reactjs.org/" rel="noopener noreferrer" target="_blank">React</a>
                        {' '}
                        — Design by
                        {' '}
                        <a href={theme.author.profile_url} target="_blank" rel="noopener noreferrer">
                            {theme.author.name}
                        </a>
                    </div>
                    <div className="site-footer__payments">
                        <img src="images/payments.png" alt="" />
                    </div>
                </div> */}
            </div>
            <ToTop />
        </div>
    );
}
